//new card same visitor.
import React from "react";
import productCardIni from "./productCardIni";
import store from "../store";
import {fetchVisitorByUUID} from "../reduxLib/visitorLib";
import {
    deleteShoppingCard,
    fetchShoppingCardByVisitorRelID,
    removeItemFromShoppingCard
} from "../reduxLib/shoppingcardLib";

function resetProductCard() {
    localStorage.removeItem("productCard");
    /*store
        .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
        .unwrap()
        .then(visitor => {
            console.log("Visitor:", visitor);
            return store
                .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                .unwrap();
        })
        .then(shoppingCard => {
            console.log("ShoppingCard:", shoppingCard);
            return store
                .dispatch(
                    deleteShoppingCard(shoppingCard.shoppingCardId
                    )
                )
                .unwrap();
        })
        .then(result => {
            console.log("AddItem result:", result);
        })
        .catch(err => {
            console.error("ERROR:", err);
        });*/
    productCardIni();
}

export default resetProductCard;